if (!customElements.get('collection-audio-banner')) {
  customElements.define('collection-audio-banner', class extends HTMLElement {
    connectedCallback() {
      this.audio = this.querySelector('audio');
      this.button = this.querySelector('[data-audio-toggle]');
      if (!this.audio || !this.button) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.showError = () => {
        this.querySelector('[data-audio-error]').hidden = false;
        this.update(false);
      };
      this.button.addEventListener('click', () => {
        if (!this.audio.paused) {
          this.audio.pause();
          return;
        }
        this.querySelector('[data-audio-error]').hidden = true;
        this.audio.play().catch(this.showError);
      }, options);
      this.audio.addEventListener('play', () => {
        document.querySelectorAll('collection-audio-banner audio').forEach(audio => {
          if (audio !== this.audio) audio.pause();
        });
        this.update(true);
      }, options);
      ['pause', 'ended'].forEach(event => this.audio.addEventListener(event, () => this.update(false), options));
      this.audio.addEventListener('error', this.showError, options);
      this.audio.hidden = true;
      this.button.hidden = false;
      this.update(!this.audio.paused);
    }

    update(playing) {
      this.button.setAttribute('aria-pressed', String(playing));
      this.querySelector('[data-audio-play]').hidden = playing;
      this.querySelector('[data-audio-play-icon]').hidden = playing;
      this.querySelector('[data-audio-pause]').hidden = !playing;
      this.querySelector('[data-audio-pause-icon]').hidden = !playing;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.audio?.pause();
    }
  });
}
